<template lang="pug">
  //- Автоперекладач браузера робить з голих чисел днів 17/18/19/21
  //- «17 років», «21 рік» тощо. translate="no" захищає поле, а попап
  //- vue2-datepicker переноситься в body (appendToBody), тому йому
  //- окремо потрібен клас notranslate
  date-picker.pointer(
    translate="no"
    popup-class="notranslate"
    v-model="val"
    :valueType="valueType"
    :format='format'
    :placeholder="placeholder"
    :disabled-date="disabledDate"
    :lang="lang"
    :range="range"
    range-separator=" - "
    :type="pickerType"
    @input="$emit('update-date', val)"
    @change="$emit('update-date', val)"
  )
</template>

<script>
import 'vue2-datepicker/locale/en'
import 'vue2-datepicker/locale/ru'
import 'vue2-datepicker/locale/uk'

import DatePicker from 'vue2-datepicker'

export default {
  name: 'date-pick',
  components: {
    DatePicker,
  },
  props: {
    format: String,
    valueType: String,
    value: {},
    placeholder: String,
    range: Boolean,
    disabledDate: Function,
    pickerType: {
      default: 'date',
      type: String,
    },
  },
  created() {
    DatePicker.locale(window.language)
  },
  data() {
    return {
      val: this.value,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
    }
  },
  watch: {
    value: {
      deep: true,
      handler(nval) {
        this.val = nval
      },
    },
  },
}
</script>
